import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import JuniorSchool from "./components/JuniorSchool";
import Boarding from "./components/Boarding";
import SportsHome from "./components/SportsHome";
import Difference from "./components/Difference";
import Pillars from "./components/Pillars";
import Infrastructure from "./components/Infrastructure";
import Admissions from "./components/Admissions";
import EventsSection from "./components/EventsSection";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import EnquiryDialog from "./components/EnquiryDialog";
import WhatsAppButton from "./components/WhatsAppButton";
import AIAssistant from "./components/AIAssistant";
import { Toaster } from "./components/ui/sonner";

// Inner pages
import JuniorSchoolPage from "./components/JuniorSchoolPage";
import MontessoriPage from "./components/MontessoriPage";
import RealWorldPage from "./components/RealWorldPage";
import ExaminationPage from "./components/ExaminationPage";
import KnowUsPage from "./components/KnowUsPage";
import BoardingPage from "./components/BoardingPage";
import AdmissionsPage from "./components/AdmissionsPage";
import GalleryPage from "./components/GalleryPage";
import OurCampusPage from "./components/OurCampusPage";
import SportsPage from "./components/SportsPage";
import ArtsPage from "./components/ArtsPage";
import ContactPage from "./components/ContactPage";

const Home = () => {
  const [enquireOpen, setEnquireOpen] = useState(false);
  const openEnquire = () => setEnquireOpen(true);

  return (
    <div className="bg-white">
      <Header onEnquire={openEnquire} />
      <main>
        <Hero onEnquire={openEnquire} />
        <About />
        <JuniorSchool />
        <SportsHome />
        <Boarding onEnquire={openEnquire} />
        <Difference />
        <Pillars />
        <Infrastructure />
        <Admissions onEnquire={openEnquire} />
        <EventsSection />
        <Gallery />
      </main>
      <Footer onEnquire={openEnquire} />
      <WhatsAppButton />
      <AIAssistant />
      <EnquiryDialog open={enquireOpen} onOpenChange={setEnquireOpen} />
      <Toaster position="top-center" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index.html" element={<Home />} />

          {/* Know Us */}
          <Route path="/know-us.html" element={<KnowUsPage />} />

          {/* Academics */}
          <Route path="/montessori.html" element={<MontessoriPage />} />
          <Route path="/real-world.html" element={<RealWorldPage />} />
          <Route path="/examination.html" element={<ExaminationPage />} />

          {/* Beyond Academics */}
          <Route path="/sports.html" element={<SportsPage />} />
          <Route path="/arts.html" element={<ArtsPage />} />

          {/* Junior School */}
          <Route path="/junior-school.html" element={<JuniorSchoolPage />} />
          <Route path="/junior-school" element={<JuniorSchoolPage />} />

          {/* Campus, Boarding, Admissions */}
          <Route path="/our-campus.html" element={<OurCampusPage />} />
          <Route path="/best-boarding-school-in-india.html" element={<BoardingPage />} />
          <Route path="/admissions.html" element={<AdmissionsPage />} />

          {/* Gallery, Contact */}
          <Route path="/gallery.html" element={<GalleryPage />} />
          <Route path="/gallery.php" element={<GalleryPage />} />
          <Route path="/contact-us.html" element={<ContactPage />} />
          <Route path="/contact-us.php" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
